export const aquaLogo = "/canvas/shared/images/aqua-logo.8413ccc2.png";
export const blackLogo = "/canvas/shared/images/black-logo.f36c2ac9.png";
export const blueLogo = "/canvas/shared/images/blue-logo.036a5b2a.png";
export const greenLogo = "/canvas/shared/images/green-logo.b6a0aed6.png";
export const purpleLogo = "/canvas/shared/images/purple-logo.b18d87e1.png";
export const whiteLogo = "/canvas/shared/images/white-logo.4749ca53.png";
